export default "__VITE_ASSET__BZl7bDGK__"